import { NCmsBlogGroup } from './cms-blog-group-navigation.interface';

export const CMS_BLOG_GROUP_NAVIGATION_CONFIG: NCmsBlogGroup.IConfig = {
    getSiblingsSortedByDateIterates: ['data.typeData.date'],
    getSiblingsSortedByDateOrders: ['desc']
};
